import { ItemType } from "@/@types/flows/emailTemplates/items";

export const ItemNameByType: Record<ItemType, string> = {
  [ItemType.Text]: "text",
  [ItemType.Button]: "botón",
  [ItemType.Image]: "imagen",
  [ItemType.Html]: "HTML",
  [ItemType.Footer]: "footer",
};
